import { render } from "./RecCardFooter.vue?vue&type=template&id=9ebd9156&scoped=true"
const script = {}

import "./RecCardFooter.vue?vue&type=style&index=0&id=9ebd9156&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ebd9156"]])

export default __exports__